import { parseISO, parseJSON } from 'date-fns';

export function safeJsonDate(value: string | null | undefined): Date | null {
  if (value === null || value === undefined || typeof value !== 'string') {
    return null;
  }
  try {
    return parseJSON(value);
  } catch {
    return null;
  }
}

export function safeJsonDateRequired(value: string | null | undefined): Date {
  const result = safeJsonDate(value);
  return result || new Date(0);
}

export function safeIsoDate(value: string | undefined | null): Date | null {
  if (!value || typeof value !== 'string') {
    return null;
  }
  try {
    return parseISO(value);
  } catch {
    return null;
  }
}

export function safeIsoDateRequired(value: string | undefined | null): Date {
  const result = safeIsoDate(value);
  return result || new Date(0);
}

const isoDateFormat = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)$/;
const postgresJSONBFormat = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;

function isIsoDateString(value: unknown): boolean {
  return typeof value === 'string' && (isoDateFormat.test(value) || postgresJSONBFormat.test(value));
}

export function transformDates(body: string | unknown): unknown {
  let parsedBody = body;
  if (typeof body === 'string') {
    try {
      parsedBody = JSON.parse(body);
    } catch {
      return body;
    }
  }

  return parseDates(parsedBody);
}

function parseDates(body: string | unknown) {
  if (body === null || body === undefined || typeof body !== 'object')
    return body;

  for (const key of Object.keys(body)) {
     
    // @ts-ignore
    const value = body[key];

    if (isIsoDateString(value)) {
      // @ts-ignore
      body[key] = parseISO(value);
    }
    else if (typeof value === 'object') {
      // @ts-ignore
      body[key] = parseDates(value);
    }
  }

  return body;
}
